(function ($) {

    $.fn.RollingDoorIllustrator = function () {
        return $(this).each(function () {
            var container = this;

            $(".rolling-door-list-item", container).click(function (event) {
                var elem = event.target;
                var position = $(elem).attr("data-position-id");
                $('.rolling-door-list-item.active',container).removeClass('active');
                $(elem).addClass('active');

                $('.rolling-door-content-item.active',container).removeClass('active');
                $('[data-illustrator-content=' + position + ']', container).addClass('active');
            });
        });
    };
    $(document).ready(function () {
        $('.RollingDoorIllustrator').RollingDoorIllustrator();
    });
}(jQuery));

